import * as fs from "fs";
import * as ko from "knockout";
import { RNSAPI, Routing } from "../../api";
import { MainViewModel } from "../../main";
import '../dataTable/dataTable';

export class AddressOverviewViewModel {
    addresses = ko.observableArray([]);
    selectedType = ko.observable("Mandant");
    types = ko.observableArray(["Mandant", "Gegner", "Sonstige"]);

    async loadAddresses() {
        let addresses = (await RNSAPI.getPersonsForScope(this.selectedType())).Payload.Addresses;
        this.addresses(addresses.map((a) => {
            console.log(a);
            a.actionHandlers = [{
                icon: "pencil",
                name: "Edit",
                action: () => MainViewModel.RoutingTable.showAddressView({ keyword: a.Keyword, type: this.selectedType() })
            },
            {
                icon: "trash-o",
                name: "Löschen",
                action: async () => {
                    await RNSAPI.deletePerson(a.Keyword, this.selectedType());
                    this.loadAddresses();
                }
            }
            ];

            return a;
        }));
    }

    constructor() {
        this.loadAddresses();
        this.selectedType.subscribe(() => this.loadAddresses());
    }
}

let html = fs.readFileSync(__dirname + '/overview.html', 'utf8');

ko.components.register("addressoverview-view", {
    viewModel: AddressOverviewViewModel,
    template: html
});